import type {
  PointsPurchaseOffer,
  PointsPurchaseOfferCampaign,
  PointsPurchaseOfferCampaignStatus,
  PointsPurchaseOfferDerivedStatus,
} from '~/types/loyaltyContract';

export function toStoredStatus(
  status: PointsPurchaseOfferDerivedStatus | PointsPurchaseOfferCampaignStatus,
): 'ACTIVE' | 'INACTIVE' {
  return status === 'INACTIVE' ? 'INACTIVE' : 'ACTIVE';
}

export function formatCampaignType(type: string): string {
  switch (type) {
    case 'PRICE_DISCOUNT':
      return 'Price Discount';
    case 'BONUS_POINTS':
      return 'Bonus Points';
    default:
      return type;
  }
}

export function formatCampaignScope(
  campaign: PointsPurchaseOfferCampaign,
  offersMap: Record<string, PointsPurchaseOffer>,
): { label: string; variant: 'filled' | 'outlined' } {
  if (campaign.offerId) {
    const offer = offersMap[campaign.offerId];
    const label = offer ? `Offer: ${offer.title}` : `Offer: ${campaign.offerId}`;
    return { label, variant: 'filled' };
  }
  if (campaign.currency) {
    return { label: `Currency: ${campaign.currency}`, variant: 'outlined' };
  }
  return { label: 'Global', variant: 'outlined' };
}
